import { render } from "./TabsListInner.vue?vue&type=template&id=02affe93&scoped=true"
import script from "./TabsListInner.vue?vue&type=script&lang=js"
export * from "./TabsListInner.vue?vue&type=script&lang=js"

import "./TabsListInner.vue?vue&type=style&index=0&id=02affe93&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02affe93"]])

export default __exports__